import { EventBus } from "../../../eventbus";

export default {
  props: {
    classes: {
      type: Array,
      default: () => [],
    },
    colorScheme: String,
    label: String,
    type: String,
    to: String,
    emitterName: String,
    emitterData: [String, Number, Array, Object],
    icon: String,
  },
  methods: {
    handleLink(e) {
      switch (this.type) {
        case "link":
          this.goTo(this.to, e);
          break;

        case "emitter":
          this.emit(this.emitterName, this.emitterData, e);
          break;
      }
    },

    goTo(link, e) {
      e.preventDefault();

      this.$router.push(link);
    },
    emit(name, data, e) {
      e.preventDefault();

      EventBus.$emit(name, data);
    },
  },
};
